

export default function Python(){
    return (
        <section>
            <h2>Python</h2>
        </section>
    )
}